/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Finish_BodyInputs */

const en_us2_intake_finish_body = /** @type {(inputs: Intake_Finish_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That is everything I need. I will put your plan together now.`)
};

const pt_br2_intake_finish_body = /** @type {(inputs: Intake_Finish_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É tudo o que eu precisava. Vou montar o seu programa agora.`)
};

const es_419_intake_finish_body = /** @type {(inputs: Intake_Finish_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es todo lo que necesitaba. Voy a armar tu plan ahora.`)
};

const pt_pt2_intake_finish_body = /** @type {(inputs: Intake_Finish_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É tudo o que eu precisava. Vou montar o teu plano agora.`)
};

const fr_fr2_intake_finish_body = /** @type {(inputs: Intake_Finish_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est tout ce qu'il me faut. Je prépare ton programme maintenant.`)
};

const de_de2_intake_finish_body = /** @type {(inputs: Intake_Finish_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das ist alles, was ich brauche. Ich stelle jetzt deinen Plan zusammen.`)
};

const it_it2_intake_finish_body = /** @type {(inputs: Intake_Finish_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È tutto quello che mi serve. Ora preparo la tua scheda.`)
};

/**
* | output |
* | --- |
* | "That is everything I need. I will put your plan together now." |
*
* @param {Intake_Finish_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_finish_body = /** @type {((inputs?: Intake_Finish_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Finish_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_finish_body(inputs)
	if (locale === "es-419") return es_419_intake_finish_body(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_finish_body(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_finish_body(inputs)
	if (locale === "de-DE") return de_de2_intake_finish_body(inputs)
	if (locale === "it-IT") return it_it2_intake_finish_body(inputs)
	return en_us2_intake_finish_body(inputs)
});
export { intake_finish_body as "intake.finish_body" }